/**中国城市 */
let cities = {
    //热门城市
    hot: [{
        "name_chs": "北京",
        "pinyin": "beijing"
    }, {
        "name_chs": "上海",
        "pinyin": "shanghai"
    }, {
        "name_chs": "深圳",
        "pinyin": "shenzheng"
    }, {
        "name_chs": "杭州",
        "pinyin": "hangzhou"
    }, {
        "name_chs": "广州",
        "pinyin": "guangzhou"
    }, {
        "name_chs": "武汉",
        "pinyin": "wuhan"
    }, {
        "name_chs": "重庆",
        "pinyin": "chongqing"
    }, {
        "name_chs": "成都",
        "pinyin": "chengdu"
    }, {
        "name_chs": "苏州",
        "pinyin": "suzhou"
    }],
    //所有城市
    all: {
        "A": [{
            "location_id": "520",
            "abbr": "8",
            "name_chs": "安庆",
            "location_type": "2",
            "parent_id": "252",
            "pinyin": "anqing"
        }, {
            "location_id": "771",
            "abbr": "9",
            "name_chs": "安康",
            "location_type": "2",
            "parent_id": "267",
            "pinyin": "ankang"
        }, {
            "location_id": "252",
            "abbr": "34",
            "name_chs": "安徽",
            "location_type": "1",
            "parent_id": "1",
            "pinyin": "anhui"
        }, {
            "location_id": "570",
            "abbr": "5",
            "name_chs": "安阳",
            "location_type": "2",
            "parent_id": "256",
            "pinyin": "anyang"
        }, {
            "location_id": "734",
            "abbr": "4",
            "name_chs": "安顺",
            "location_type": "2",
            "parent_id": "264",
            "pinyin": "anshun"
        }, {
            "location_id": "274",
            "abbr": "82",
            "name_chs": "澳门",
            "location_type": "1",
            "parent_id": "1",
            "pinyin": "aomen"
        }, {
            "location_id": "807",
            "abbr": "29",
            "name_chs": "阿克苏",
            "location_type": "2",
            "parent_id": "271",
            "pinyin": "akesu"
        }, {
            "location_id": "813",
            "abbr": "43",
            "name_chs": "阿勒泰",
            "location_type": "2",
            "parent_id": "271",
            "pinyin": "aletai"
        }, {
            "location_id": "728",
            "abbr": "32",
            "name_chs": "阿坝",
            "location_type": "2",
            "parent_id": "263",
            "pinyin": "aba"
        }, {
            "location_id": "434",
            "abbr": "29",
            "name_chs": "阿拉善盟",
            "location_type": "2",
            "parent_id": "245",
            "pinyin": "alashan"
        }, {
            "location_id": "815",
            "abbr": "92",
            "name_chs": "阿拉尔",
            "location_type": "2",
            "parent_id": "271",
            "pinyin": "alaer"
        }, {
            "location_id": "761",
            "abbr": "25",
            "name_chs": "阿里",
            "location_type": "2",
            "parent_id": "266",
            "pinyin": "ali"
        }, {
            "location_id": "437",
            "abbr": "3",
            "name_chs": "鞍山",
            "location_type": "2",
            "parent_id": "246",
            "pinyin": "anshan"
        }],
        "B": [{
            "location_id": "406",
            "abbr": "6",
            "name_chs": "保定",
            "location_type": "2",
            "parent_id": "243",
            "pinyin": "baoding"
        }, {
            "location_id": "743",
            "abbr": "5",
            "name_chs": "保山",
            "location_type": "2",
            "parent_id": "265",
            "pinyin": "baoshan"
        }, {
            "location_id": "424",
            "abbr": "2",
            "name_chs": "包头",
            "location_type": "2",
            "parent_id": "245",
            "pinyin": "baotou"
        }, {
            "location_id": "241",
            "abbr": "11",
            "name_chs": "北京",
            "location_type": "1",
            "parent_id": "1",
            "pinyin": "beijing"
        }, {
            "location_id": "818",
            "abbr": "95",
            "name_chs": "北屯",
            "location_type": "2",
            "parent_id": "271",
            "pinyin": "beitun"
        }, {
            "location_id": "640",
            "abbr": "5",
            "name_chs": "北海",
            "location_type": "2",
            "parent_id": "260",
            "pinyin": "beihai"
        }, {
            "location_id": "805",
            "abbr": "27",
            "name_chs": "博尔塔拉",
            "location_type": "2",
            "parent_id": "271",
            "pinyin": "boertala"
        }, {
            "location_id": "765",
            "abbr": "3",
            "name_chs": "宝鸡",
            "location_type": "2",
            "parent_id": "267",
            "pinyin": "baoji"
        }, {
            "location_id": "726",
            "abbr": "19",
            "name_chs": "巴中",
            "location_type": "2",
            "parent_id": "263",
            "pinyin": "bazhong"
        }, {
            "location_id": "430",
            "abbr": "8",
            "name_chs": "巴彦淖尔",
            "location_type": "2",
            "parent_id": "245",
            "pinyin": "bayannaoer"
        }, {
            "location_id": "806",
            "abbr": "28",
            "name_chs": "巴音郭楞",
            "location_type": "2",
            "parent_id": "271",
            "pinyin": "bayinguoleng"
        }, {
            "location_id": "439",
            "abbr": "5",
            "name_chs": "本溪",
            "location_type": "2",
            "parent_id": "246",
            "pinyin": "benxi"
        }, {
            "location_id": "737",
            "abbr": "24",
            "name_chs": "毕节",
            "location_type": "2",
            "parent_id": "264",
            "pinyin": "bijie"
        }, {
            "location_id": "564",
            "abbr": "16",
            "name_chs": "滨州",
            "location_type": "2",
            "parent_id": "255",
            "pinyin": "binzhou"
        }, {
            "location_id": "456",
            "abbr": "8",
            "name_chs": "白城",
            "location_type": "2",
            "parent_id": "247",
            "pinyin": "baicheng"
        }, {
            "location_id": "454",
            "abbr": "6",
            "name_chs": "白山",
            "location_type": "2",
            "parent_id": "247",
            "pinyin": "baishan"
        }, {
            "location_id": "776",
            "abbr": "4",
            "name_chs": "白银",
            "location_type": "2",
            "parent_id": "268",
            "pinyin": "baiyin"
        }, {
            "location_id": "645",
            "abbr": "10",
            "name_chs": "百色",
            "location_type": "2",
            "parent_id": "260",
            "pinyin": "baise"
        }, {
            "location_id": "515",
            "abbr": "3",
            "name_chs": "蚌埠",
            "location_type": "2",
            "parent_id": "252",
            "pinyin": "bangbu"
        }],
        "C": [{
            "location_id": "649",
            "abbr": "14",
            "name_chs": "崇左",
            "location_type": "2",
            "parent_id": "260",
            "pinyin": "chongzuo"
        }, {
            "location_id": "492",
            "abbr": "4",
            "name_chs": "常州",
            "location_type": "2",
            "parent_id": "250",
            "pinyin": "changzhou"
        }, {
            "location_id": "607",
            "abbr": "7",
            "name_chs": "常德",
            "location_type": "2",
            "parent_id": "258",
            "pinyin": "changde"
        }, {
            "location_id": "710",
            "abbr": "1",
            "name_chs": "成都",
            "location_type": "2",
            "parent_id": "263",
            "pinyin": "chengdu"
        }, {
            "location_id": "408",
            "abbr": "8",
            "name_chs": "承德",
            "location_type": "2",
            "parent_id": "243",
            "pinyin": "chengde"
        }, {
            "location_id": "804",
            "abbr": "23",
            "name_chs": "昌吉",
            "location_type": "2",
            "parent_id": "271",
            "pinyin": "changji"
        }, {
            "location_id": "757",
            "abbr": "21",
            "name_chs": "昌都",
            "location_type": "2",
            "parent_id": "266",
            "pinyin": "changdu"
        }, {
            "location_id": "447",
            "abbr": "13",
            "name_chs": "朝阳",
            "location_type": "2",
            "parent_id": "246",
            "pinyin": "chaoyang"
        }, {
            "location_id": "748",
            "abbr": "23",
            "name_chs": "楚雄",
            "location_type": "2",
            "parent_id": "265",
            "pinyin": "chuxiong"
        }, {
            "location_id": "527",
            "abbr": "17",
            "name_chs": "池州",
            "location_type": "2",
            "parent_id": "252",
            "pinyin": "chizhou"
        }, {
            "location_id": "409",
            "abbr": "9",
            "name_chs": "沧州",
            "location_type": "2",
            "parent_id": "243",
            "pinyin": "cangzhou"
        }, {
            "location_id": "522",
            "abbr": "11",
            "name_chs": "滁州",
            "location_type": "2",
            "parent_id": "252",
            "pinyin": "chuzhou"
        }, {
            "location_id": "633",
            "abbr": "51",
            "name_chs": "潮州",
            "location_type": "2",
            "parent_id": "259",
            "pinyin": "chaozhou"
        }, {
            "location_id": "426",
            "abbr": "4",
            "name_chs": "赤峰",
            "location_type": "2",
            "parent_id": "245",
            "pinyin": "chifeng"
        }, {
            "location_id": "610",
            "abbr": "10",
            "name_chs": "郴州",
            "location_type": "2",
            "parent_id": "258",
            "pinyin": "chenzhou"
        }, {
            "location_id": "262",
            "abbr": "50",
            "name_chs": "重庆",
            "location_type": "1",
            "parent_id": "1",
            "pinyin": "chongqing"
        }, {
            "location_id": "449",
            "abbr": "1",
            "name_chs": "长春",
            "location_type": "2",
            "parent_id": "247",
            "pinyin": "changchun"
        }, {
            "location_id": "601",
            "abbr": "1",
            "name_chs": "长沙",
            "location_type": "2",
            "parent_id": "258",
            "pinyin": "changsha"
        }, {
            "location_id": "415",
            "abbr": "4",
            "name_chs": "长治",
            "location_type": "2",
            "parent_id": "244",
            "pinyin": "changzhi"
        }],
        "D": [{
            "location_id": "658",
            "abbr": "97",
            "name_chs": "东方市",
            "location_type": "2",
            "parent_id": "261",
            "pinyin": "dongfang"
        }, {
            "location_id": "631",
            "abbr": "19",
            "name_chs": "东莞",
            "location_type": "2",
            "parent_id": "259",
            "pinyin": "dong"
        }, {
            "location_id": "553",
            "abbr": "5",
            "name_chs": "东营",
            "location_type": "2",
            "parent_id": "255",
            "pinyin": "dongying"
        }, {
            "location_id": "440",
            "abbr": "6",
            "name_chs": "丹东",
            "location_type": "2",
            "parent_id": "246",
            "pinyin": "dandong"
        }, {
            "location_id": "470",
            "abbr": "27",
            "name_chs": "大兴安岭地区",
            "location_type": "2",
            "parent_id": "248",
            "pinyin": "daxinganling"
        }, {
            "location_id": "413",
            "abbr": "2",
            "name_chs": "大同",
            "location_type": "2",
            "parent_id": "244",
            "pinyin": "datong"
        }, {
            "location_id": "463",
            "abbr": "6",
            "name_chs": "大庆",
            "location_type": "2",
            "parent_id": "248",
            "pinyin": "daqing"
        }, {
            "location_id": "752",
            "abbr": "29",
            "name_chs": "大理",
            "location_type": "2",
            "parent_id": "265",
            "pinyin": "dali"
        }, {
            "location_id": "436",
            "abbr": "2",
            "name_chs": "大连",
            "location_type": "2",
            "parent_id": "246",
            "pinyin": "dalian"
        }, {
            "location_id": "783",
            "abbr": "11",
            "name_chs": "定西",
            "location_type": "2",
            "parent_id": "268",
            "pinyin": "dingxi"
        }, {
            "location_id": "753",
            "abbr": "31",
            "name_chs": "德宏",
            "location_type": "2",
            "parent_id": "265",
            "pinyin": "dehong"
        }, {
            "location_id": "562",
            "abbr": "14",
            "name_chs": "德州",
            "location_type": "2",
            "parent_id": "255",
            "pinyin": "dezhou"
        }, {
            "location_id": "714",
            "abbr": "6",
            "name_chs": "德阳",
            "location_type": "2",
            "parent_id": "263",
            "pinyin": "deyang"
        }, {
            "location_id": "724",
            "abbr": "17",
            "name_chs": "达州",
            "location_type": "2",
            "parent_id": "263",
            "pinyin": "dazhou"
        }, {
            "location_id": "755",
            "abbr": "34",
            "name_chs": "迪庆",
            "location_type": "2",
            "parent_id": "265",
            "pinyin": "diqing"
        }],
        "E": [{
            "location_id": "596",
            "abbr": "28",
            "name_chs": "恩施",
            "location_type": "2",
            "parent_id": "257",
            "pinyin": "enshi"
        }, {
            "location_id": "428",
            "abbr": "6",
            "name_chs": "鄂尔多斯",
            "location_type": "2",
            "parent_id": "245",
            "pinyin": "eerduosi"
        }, {
            "location_id": "589",
            "abbr": "7",
            "name_chs": "鄂州",
            "location_type": "2",
            "parent_id": "257",
            "pinyin": "ezhou"
        }],
        "F": [{
            "location_id": "620",
            "abbr": "6",
            "name_chs": "佛山",
            "location_type": "2",
            "parent_id": "259",
            "pinyin": "foshan"
        }, {
            "location_id": "547",
            "abbr": "10",
            "name_chs": "抚州",
            "location_type": "2",
            "parent_id": "254",
            "pinyin": "fuzhou"
        }, {
            "location_id": "438",
            "abbr": "4",
            "name_chs": "抚顺",
            "location_type": "2",
            "parent_id": "246",
            "pinyin": "fushun"
        }, {
            "location_id": "529",
            "abbr": "1",
            "name_chs": "福州",
            "location_type": "2",
            "parent_id": "253",
            "pinyin": "fuzhou"
        }, {
            "location_id": "253",
            "abbr": "35",
            "name_chs": "福建",
            "location_type": "1",
            "parent_id": "1",
            "pinyin": "fujian"
        }, {
            "location_id": "443",
            "abbr": "9",
            "name_chs": "阜新",
            "location_type": "2",
            "parent_id": "246",
            "pinyin": "fuxin"
        }, {
            "location_id": "523",
            "abbr": "12",
            "name_chs": "阜阳",
            "location_type": "2",
            "parent_id": "252",
            "pinyin": "fuyang"
        }, {
            "location_id": "641",
            "abbr": "6",
            "name_chs": "防城港",
            "location_type": "2",
            "parent_id": "260",
            "pinyin": "fangchenggang"
        }],
        "G": [{
            "location_id": "798",
            "abbr": "4",
            "name_chs": "固原",
            "location_type": "2",
            "parent_id": "270",
            "pinyin": "guyuan"
        }, {
            "location_id": "259",
            "abbr": "44",
            "name_chs": "广东",
            "location_type": "1",
            "parent_id": "1",
            "pinyin": "guangdong"
        }, {
            "location_id": "716",
            "abbr": "8",
            "name_chs": "广元",
            "location_type": "2",
            "parent_id": "263",
            "pinyin": "guangyuan"
        }, {
            "location_id": "723",
            "abbr": "16",
            "name_chs": "广安",
            "location_type": "2",
            "parent_id": "263",
            "pinyin": "guangan"
        }, {
            "location_id": "615",
            "abbr": "1",
            "name_chs": "广州",
            "location_type": "2",
            "parent_id": "259",
            "pinyin": "guangzhou"
        }, {
            "location_id": "260",
            "abbr": "45",
            "name_chs": "广西",
            "location_type": "1",
            "parent_id": "1",
            "pinyin": "guangxi"
        }, {
            "location_id": "792",
            "abbr": "26",
            "name_chs": "果洛",
            "location_type": "2",
            "parent_id": "269",
            "pinyin": "guoluo"
        }, {
            "location_id": "638",
            "abbr": "3",
            "name_chs": "桂林",
            "location_type": "2",
            "parent_id": "260",
            "pinyin": "guilin"
        }, {
            "location_id": "786",
            "abbr": "30",
            "name_chs": "甘南",
            "location_type": "2",
            "parent_id": "268",
            "pinyin": "gannan"
        }, {
            "location_id": "729",
            "abbr": "33",
            "name_chs": "甘孜",
            "location_type": "2",
            "parent_id": "263",
            "pinyin": "ganzi"
        }, {
            "location_id": "268",
            "abbr": "62",
            "name_chs": "甘肃",
            "location_type": "1",
            "parent_id": "1",
            "pinyin": "gansu"
        }, {
            "location_id": "264",
            "abbr": "52",
            "name_chs": "贵州",
            "location_type": "1",
            "parent_id": "1",
            "pinyin": "guizhou"
        }, {
            "location_id": "643",
            "abbr": "8",
            "name_chs": "贵港",
            "location_type": "2",
            "parent_id": "260",
            "pinyin": "guigang"
        }, {
            "location_id": "731",
            "abbr": "1",
            "name_chs": "贵阳",
            "location_type": "2",
            "parent_id": "264",
            "pinyin": "guiyang"
        }, {
            "location_id": "544",
            "abbr": "7",
            "name_chs": "赣州",
            "location_type": "2",
            "parent_id": "254",
            "pinyin": "ganzhou"
        }, {
            "location_id": "820",
            "abbr": "2",
            "name_chs": "高雄市",
            "location_type": "2",
            "parent_id": "272",
            "pinyin": "gaoxiongshi"
        }],
        "H": [{
            "location_id": "513",
            "abbr": "1",
            "name_chs": "合肥",
            "location_type": "2",
            "parent_id": "252",
            "pinyin": "hefei"
        }, {
            "location_id": "429",
            "abbr": "7",
            "name_chs": "呼伦贝尔",
            "location_type": "2",
            "parent_id": "245",
            "pinyin": "hulunbeier"
        }, {
            "location_id": "423",
            "abbr": "1",
            "name_chs": "呼和浩特",
            "location_type": "2",
            "parent_id": "245",
            "pinyin": "huhehaote"
        }, {
            "location_id": "810",
            "abbr": "32",
            "name_chs": "和田",
            "location_type": "2",
            "parent_id": "271",
            "pinyin": "hetian"
        }, {
            "location_id": "803",
            "abbr": "22",
            "name_chs": "哈密",
            "location_type": "2",
            "parent_id": "271",
            "pinyin": "hami"
        }, {
            "location_id": "458",
            "abbr": "1",
            "name_chs": "哈尔滨",
            "location_type": "2",
            "parent_id": "248",
            "pinyin": "haerbin"
        }, {
            "location_id": "612",
            "abbr": "12",
            "name_chs": "怀化",
            "location_type": "2",
            "parent_id": "258",
            "pinyin": "huaihua"
        }, {
            "location_id": "625",
            "abbr": "13",
            "name_chs": "惠州",
            "location_type": "2",
            "parent_id": "259",
            "pinyin": "huizhou"
        }, {
            "location_id": "502",
            "abbr": "1",
            "name_chs": "杭州",
            "location_type": "2",
            "parent_id": "251",
            "pinyin": "hangzhou"
        }, {
            "location_id": "769",
            "abbr": "7",
            "name_chs": "汉中",
            "location_type": "2",
            "parent_id": "267",
            "pinyin": "hanzhong"
        }, {
            "location_id": "243",
            "abbr": "13",
            "name_chs": "河北",
            "location_type": "1",
            "parent_id": "1",
            "pinyin": "hebei"
        }, {
            "location_id": "256",
            "abbr": "41",
            "name_chs": "河南",
            "location_type": "1",
            "parent_id": "1",
            "pinyin": "henan"
        }, {
            "location_id": "647",
            "abbr": "12",
            "name_chs": "河池",
            "location_type": "2",
            "parent_id": "260",
            "pinyin": "hechi"
        }, {
            "location_id": "628",
            "abbr": "16",
            "name_chs": "河源",
            "location_type": "2",
            "parent_id": "259",
            "pinyin": "heyuan"
        }, {
            "location_id": "788",
            "abbr": "21",
            "name_chs": "海东",
            "location_type": "2",
            "parent_id": "269",
            "pinyin": "haidong"
        }, {
            "location_id": "789",
            "abbr": "22",
            "name_chs": "海北",
            "location_type": "2",
            "parent_id": "269",
            "pinyin": "haibei"
        }, {
            "location_id": "261",
            "abbr": "46",
            "name_chs": "海南",
            "location_type": "1",
            "parent_id": "1",
            "pinyin": "hainan"
        }, {
            "location_id": "650",
            "abbr": "1",
            "name_chs": "海口",
            "location_type": "2",
            "parent_id": "261",
            "pinyin": "haikou"
        }, {
            "location_id": "794",
            "abbr": "28",
            "name_chs": "海西",
            "location_type": "2",
            "parent_id": "269",
            "pinyin": "haixi"
        }, {
            "location_id": "518",
            "abbr": "6",
            "name_chs": "淮北",
            "location_type": "2",
            "parent_id": "252",
            "pinyin": "huaibei"
        }, {
            "location_id": "516",
            "abbr": "4",
            "name_chs": "淮南",
            "location_type": "2",
            "parent_id": "252",
            "pinyin": "huainan"
        }, {
            "location_id": "496",
            "abbr": "8",
            "name_chs": "淮安",
            "location_type": "2",
            "parent_id": "250",
            "pinyin": "huaian"
        }, {
            "location_id": "257",
            "abbr": "42",
            "name_chs": "湖北",
            "location_type": "1",
            "parent_id": "1",
            "pinyin": "hubei"
        }, {
            "location_id": "258",
            "abbr": "43",
            "name_chs": "湖南",
            "location_type": "1",
            "parent_id": "1",
            "pinyin": "hunan"
        }, {
            "location_id": "506",
            "abbr": "5",
            "name_chs": "湖州",
            "location_type": "2",
            "parent_id": "251",
            "pinyin": "huzhou"
        }, {
            "location_id": "576",
            "abbr": "11",
            "name_chs": "漯河",
            "location_type": "2",
            "parent_id": "256",
            "pinyin": "he"
        }, {
            "location_id": "749",
            "abbr": "25",
            "name_chs": "红河",
            "location_type": "2",
            "parent_id": "265",
            "pinyin": "honghe"
        }, {
            "location_id": "565",
            "abbr": "17",
            "name_chs": "菏泽",
            "location_type": "2",
            "parent_id": "255",
            "pinyin": "heze"
        }, {
            "location_id": "448",
            "abbr": "14",
            "name_chs": "葫芦岛",
            "location_type": "2",
            "parent_id": "246",
            "pinyin": "huludao"
        }, {
            "location_id": "411",
            "abbr": "11",
            "name_chs": "衡水",
            "location_type": "2",
            "parent_id": "243",
            "pinyin": "hengshui"
        }, {
            "location_id": "604",
            "abbr": "4",
            "name_chs": "衡阳",
            "location_type": "2",
            "parent_id": "258",
            "pinyin": "hengyang"
        }, {
            "location_id": "646",
            "abbr": "11",
            "name_chs": "贺州",
            "location_type": "2",
            "parent_id": "260",
            "pinyin": "hezhou"
        }, {
            "location_id": "404",
            "abbr": "4",
            "name_chs": "邯郸",
            "location_type": "2",
            "parent_id": "243",
            "pinyin": "handan"
        }, {
            "location_id": "571",
            "abbr": "6",
            "name_chs": "鹤壁",
            "location_type": "2",
            "parent_id": "256",
            "pinyin": "hebi"
        }, {
            "location_id": "461",
            "abbr": "4",
            "name_chs": "鹤岗",
            "location_type": "2",
            "parent_id": "248",
            "pinyin": "hegang"
        }, {
            "location_id": "593",
            "abbr": "11",
            "name_chs": "黄冈",
            "location_type": "2",
            "parent_id": "257",
            "pinyin": "huanggang"
        }, {
            "location_id": "790",
            "abbr": "23",
            "name_chs": "黄南",
            "location_type": "2",
            "parent_id": "269",
            "pinyin": "huangnan"
        }, {
            "location_id": "521",
            "abbr": "10",
            "name_chs": "黄山",
            "location_type": "2",
            "parent_id": "252",
            "pinyin": "huangshan"
        }, {
            "location_id": "585",
            "abbr": "2",
            "name_chs": "黄石",
            "location_type": "2",
            "parent_id": "257",
            "pinyin": "huangshi"
        }, {
            "location_id": "468",
            "abbr": "11",
            "name_chs": "黑河",
            "location_type": "2",
            "parent_id": "248",
            "pinyin": "heihe"
        }, {
            "location_id": "248",
            "abbr": "23",
            "name_chs": "黑龙江",
            "location_type": "1",
            "parent_id": "1",
            "pinyin": "heilongjiang"
        }],
        "J": [{
            "location_id": "541",
            "abbr": "4",
            "name_chs": "九江",
            "location_type": "2",
            "parent_id": "254",
            "pinyin": "jiujiang"
        }, {
            "location_id": "465",
            "abbr": "8",
            "name_chs": "佳木斯",
            "location_type": "2",
            "parent_id": "248",
            "pinyin": "jiamusi"
        }, {
            "location_id": "545",
            "abbr": "8",
            "name_chs": "吉安",
            "location_type": "2",
            "parent_id": "254",
            "pinyin": "jian"
        }, {
            "location_id": "247",
            "abbr": "22",
            "name_chs": "吉林",
            "location_type": "1",
            "parent_id": "1",
            "pinyin": "jilin"
        }, {
            "location_id": "825",
            "abbr": "7",
            "name_chs": "嘉义市",
            "location_type": "2",
            "parent_id": "272",
            "pinyin": "jiayishi"
        }, {
            "location_id": "505",
            "abbr": "4",
            "name_chs": "嘉兴",
            "location_type": "2",
            "parent_id": "251",
            "pinyin": "jiaxing"
        }, {
            "location_id": "774",
            "abbr": "2",
            "name_chs": "嘉峪关",
            "location_type": "2",
            "parent_id": "268",
            "pinyin": "jiayuguan"
        }, {
            "location_id": "821",
            "abbr": "3",
            "name_chs": "基隆市",
            "location_type": "2",
            "parent_id": "272",
            "pinyin": "jilongshi"
        }, {
            "location_id": "634",
            "abbr": "52",
            "name_chs": "揭阳",
            "location_type": "2",
            "parent_id": "259",
            "pinyin": "jieyang"
        }, {
            "location_id": "418",
            "abbr": "7",
            "name_chs": "晋中",
            "location_type": "2",
            "parent_id": "244",
            "pinyin": "jinzhong"
        }, {
            "location_id": "416",
            "abbr": "5",
            "name_chs": "晋城",
            "location_type": "2",
            "parent_id": "244",
            "pinyin": "jincheng"
        }, {
            "location_id": "539",
            "abbr": "2",
            "name_chs": "景德镇",
            "location_type": "2",
            "parent_id": "254",
            "pinyin": "jingdezhen"
        }, {
            "location_id": "250",
            "abbr": "32",
            "name_chs": "江苏",
            "location_type": "1",
            "parent_id": "1",
            "pinyin": "jiangsu"
        }, {
            "location_id": "254",
            "abbr": "36",
            "name_chs": "江西",
            "location_type": "1",
            "parent_id": "1",
            "pinyin": "jiangxi"
        }, {
            "location_id": "621",
            "abbr": "7",
            "name_chs": "江门",
            "location_type": "2",
            "parent_id": "259",
            "pinyin": "jiangmen"
        }, {
            "location_id": "549",
            "abbr": "1",
            "name_chs": "济南",
            "location_type": "2",
            "parent_id": "255",
            "pinyin": "jinan"
        }, {
            "location_id": "556",
            "abbr": "8",
            "name_chs": "济宁",
            "location_type": "2",
            "parent_id": "255",
            "pinyin": "jining"
        }, {
            "location_id": "583",
            "abbr": "18",
            "name_chs": "济源",
            "location_type": "2",
            "parent_id": "256",
            "pinyin": "jiyuan"
        }, {
            "location_id": "573",
            "abbr": "8",
            "name_chs": "焦作",
            "location_type": "2",
            "parent_id": "256",
            "pinyin": "jiaozuo"
        }, {
            "location_id": "592",
            "abbr": "10",
            "name_chs": "荆州",
            "location_type": "2",
            "parent_id": "257",
            "pinyin": "jingzhou"
        }, {
            "location_id": "590",
            "abbr": "8",
            "name_chs": "荆门",
            "location_type": "2",
            "parent_id": "257",
            "pinyin": "jingmen"
        }, {
            "location_id": "781",
            "abbr": "9",
            "name_chs": "酒泉",
            "location_type": "2",
            "parent_id": "268",
            "pinyin": "jiuquan"
        }, {
            "location_id": "508",
            "abbr": "7",
            "name_chs": "金华",
            "location_type": "2",
            "parent_id": "251",
            "pinyin": "jinhua"
        }, {
            "location_id": "775",
            "abbr": "3",
            "name_chs": "金昌",
            "location_type": "2",
            "parent_id": "268",
            "pinyin": "jinchang"
        }, {
            "location_id": "441",
            "abbr": "7",
            "name_chs": "锦州",
            "location_type": "2",
            "parent_id": "246",
            "pinyin": "jinzhou"
        }, {
            "location_id": "460",
            "abbr": "3",
            "name_chs": "鸡西",
            "location_type": "2",
            "parent_id": "248",
            "pinyin": "jixi"
        }],
        "K": [{
            "location_id": "808",
            "abbr": "30",
            "name_chs": "克孜勒苏",
            "location_type": "2",
            "parent_id": "271",
            "pinyin": "kezilesu"
        }, {
            "location_id": "801",
            "abbr": "2",
            "name_chs": "克拉玛依",
            "location_type": "2",
            "parent_id": "271",
            "pinyin": "kelamayi"
        }, {
            "location_id": "809",
            "abbr": "31",
            "name_chs": "喀什",
            "location_type": "2",
            "parent_id": "271",
            "pinyin": "kashi"
        }, {
            "location_id": "567",
            "abbr": "2",
            "name_chs": "开封",
            "location_type": "2",
            "parent_id": "256",
            "pinyin": "kaifeng"
        }, {
            "location_id": "740",
            "abbr": "1",
            "name_chs": "昆明",
            "location_type": "2",
            "parent_id": "265",
            "pinyin": "kunming"
        }],
        "L": [{
            "location_id": "785",
            "abbr": "29",
            "name_chs": "临夏",
            "location_type": "2",
            "parent_id": "268",
            "pinyin": "linxia"
        }, {
            "location_id": "421",
            "abbr": "10",
            "name_chs": "临汾",
            "location_type": "2",
            "parent_id": "244",
            "pinyin": "linfen"
        }, {
            "location_id": "561",
            "abbr": "13",
            "name_chs": "临沂",
            "location_type": "2",
            "parent_id": "255",
            "pinyin": "linyi"
        }, {
            "location_id": "747",
            "abbr": "9",
            "name_chs": "临沧",
            "location_type": "2",
            "parent_id": "265",
            "pinyin": "lincang"
        }, {
            "location_id": "512",
            "abbr": "11",
            "name_chs": "丽水",
            "location_type": "2",
            "parent_id": "251",
            "pinyin": "lishui"
        }, {
            "location_id": "745",
            "abbr": "7",
            "name_chs": "丽江",
            "location_type": "2",
            "parent_id": "265",
            "pinyin": "lijiang"
        }, {
            "location_id": "719",
            "abbr": "11",
            "name_chs": "乐山",
            "location_type": "2",
            "parent_id": "263",
            "pinyin": "leshan"
        }, {
            "location_id": "525",
            "abbr": "15",
            "name_chs": "六安",
            "location_type": "2",
            "parent_id": "252",
            "pinyin": "liuan"
        }, {
            "location_id": "732",
            "abbr": "2",
            "name_chs": "六盘水",
            "location_type": "2",
            "parent_id": "264",
            "pinyin": "liupanshui"
        }, {
            "location_id": "773",
            "abbr": "1",
            "name_chs": "兰州市",
            "location_type": "2",
            "parent_id": "268",
            "pinyin": "lanzhoushi"
        }, {
            "location_id": "730",
            "abbr": "34",
            "name_chs": "凉山",
            "location_type": "2",
            "parent_id": "263",
            "pinyin": "liangshan"
        }, {
            "location_id": "422",
            "abbr": "11",
            "name_chs": "吕梁",
            "location_type": "2",
            "parent_id": "244",
            "pinyin": "lvliang"
        }, {
            "location_id": "613",
            "abbr": "13",
            "name_chs": "娄底",
            "location_type": "2",
            "parent_id": "258",
            "pinyin": "loudi"
        }, {
            "location_id": "410",
            "abbr": "10",
            "name_chs": "廊坊",
            "location_type": "2",
            "parent_id": "243",
            "pinyin": "langfang"
        }, {
            "location_id": "756",
            "abbr": "1",
            "name_chs": "拉萨",
            "location_type": "2",
            "parent_id": "266",
            "pinyin": "lasa"
        }, {
            "location_id": "648",
            "abbr": "13",
            "name_chs": "来宾",
            "location_type": "2",
            "parent_id": "260",
            "pinyin": "laibin"
        }, {
            "location_id": "762",
            "abbr": "26",
            "name_chs": "林芝",
            "location_type": "2",
            "parent_id": "266",
            "pinyin": "linzhi"
        }, {
            "location_id": "637",
            "abbr": "2",
            "name_chs": "柳州",
            "location_type": "2",
            "parent_id": "260",
            "pinyin": "liuzhou"
        }, {
            "location_id": "568",
            "abbr": "3",
            "name_chs": "洛阳",
            "location_type": "2",
            "parent_id": "256",
            "pinyin": "luoyang"
        }, {
            "location_id": "563",
            "abbr": "15",
            "name_chs": "聊城",
            "location_type": "2",
            "parent_id": "255",
            "pinyin": "liaocheng"
        }, {
            "location_id": "560",
            "abbr": "12",
            "name_chs": "莱芜",
            "location_type": "2",
            "parent_id": "255",
            "pinyin": "laiwu"
        }, {
            "location_id": "246",
            "abbr": "21",
            "name_chs": "辽宁",
            "location_type": "1",
            "parent_id": "1",
            "pinyin": "liaoning"
        }, {
            "location_id": "452",
            "abbr": "4",
            "name_chs": "辽源",
            "location_type": "2",
            "parent_id": "247",
            "pinyin": "liaoyuan"
        }, {
            "location_id": "444",
            "abbr": "10",
            "name_chs": "辽阳",
            "location_type": "2",
            "parent_id": "246",
            "pinyin": "liaoyang"
        }, {
            "location_id": "495",
            "abbr": "7",
            "name_chs": "连云港",
            "location_type": "2",
            "parent_id": "250",
            "pinyin": "lianyungang"
        }, {
            "location_id": "784",
            "abbr": "12",
            "name_chs": "陇南",
            "location_type": "2",
            "parent_id": "268",
            "pinyin": "longnan"
        }, {
            "location_id": "536",
            "abbr": "8",
            "name_chs": "龙岩",
            "location_type": "2",
            "parent_id": "253",
            "pinyin": "longyan"
        }],
        "M": [{
            "location_id": "626",
            "abbr": "14",
            "name_chs": "梅州",
            "location_type": "2",
            "parent_id": "259",
            "pinyin": "meizhou"
        }, {
            "location_id": "467",
            "abbr": "10",
            "name_chs": "牡丹江",
            "location_type": "2",
            "parent_id": "248",
            "pinyin": "mudanjiang"
        }, {
            "location_id": "721",
            "abbr": "14",
            "name_chs": "眉山",
            "location_type": "2",
            "parent_id": "263",
            "pinyin": "meishan"
        }, {
            "location_id": "715",
            "abbr": "7",
            "name_chs": "绵阳",
            "location_type": "2",
            "parent_id": "263",
            "pinyin": "mianyang"
        }, {
            "location_id": "623",
            "abbr": "9",
            "name_chs": "茂名",
            "location_type": "2",
            "parent_id": "259",
            "pinyin": "maoming"
        }, {
            "location_id": "517",
            "abbr": "5",
            "name_chs": "马鞍山",
            "location_type": "2",
            "parent_id": "252",
            "pinyin": "maanshan"
        }],
        "N": [{
            "location_id": "718",
            "abbr": "10",
            "name_chs": "内江",
            "location_type": "2",
            "parent_id": "263",
            "pinyin": "neijiang"
        }, {
            "location_id": "245",
            "abbr": "15",
            "name_chs": "内蒙古",
            "location_type": "1",
            "parent_id": "1",
            "pinyin": "neimenggu"
        }, {
            "location_id": "489",
            "abbr": "1",
            "name_chs": "南京",
            "location_type": "2",
            "parent_id": "250",
            "pinyin": "nanjing"
        }, {
            "location_id": "720",
            "abbr": "13",
            "name_chs": "南充",
            "location_type": "2",
            "parent_id": "263",
            "pinyin": "nanchong"
        }, {
            "location_id": "636",
            "abbr": "1",
            "name_chs": "南宁",
            "location_type": "2",
            "parent_id": "260",
            "pinyin": "nanning"
        }, {
            "location_id": "535",
            "abbr": "7",
            "name_chs": "南平",
            "location_type": "2",
            "parent_id": "253",
            "pinyin": "nanping"
        }, {
            "location_id": "538",
            "abbr": "1",
            "name_chs": "南昌",
            "location_type": "2",
            "parent_id": "254",
            "pinyin": "nanchang"
        }, {
            "location_id": "494",
            "abbr": "6",
            "name_chs": "南通",
            "location_type": "2",
            "parent_id": "250",
            "pinyin": "nantong"
        }, {
            "location_id": "578",
            "abbr": "13",
            "name_chs": "南阳",
            "location_type": "2",
            "parent_id": "256",
            "pinyin": "nanyang"
        }, {
            "location_id": "270",
            "abbr": "64",
            "name_chs": "宁夏",
            "location_type": "1",
            "parent_id": "1",
            "pinyin": "ningxia"
        }, {
            "location_id": "537",
            "abbr": "9",
            "name_chs": "宁德",
            "location_type": "2",
            "parent_id": "253",
            "pinyin": "ningde"
        }, {
            "location_id": "503",
            "abbr": "2",
            "name_chs": "宁波",
            "location_type": "2",
            "parent_id": "251",
            "pinyin": "ningbo"
        }, {
            "location_id": "754",
            "abbr": "33",
            "name_chs": "怒江",
            "location_type": "2",
            "parent_id": "265",
            "pinyin": "nujiang"
        }, {
            "location_id": "760",
            "abbr": "24",
            "name_chs": "那曲",
            "location_type": "2",
            "parent_id": "266",
            "pinyin": "naqu"
        }],
        "P": [{
            "location_id": "780",
            "abbr": "8",
            "name_chs": "平凉",
            "location_type": "2",
            "parent_id": "268",
            "pinyin": "pingliang"
        }, {
            "location_id": "569",
            "abbr": "4",
            "name_chs": "平顶山",
            "location_type": "2",
            "parent_id": "256",
            "pinyin": "pingdingshan"
        }, {
            "location_id": "712",
            "abbr": "4",
            "name_chs": "攀枝花",
            "location_type": "2",
            "parent_id": "263",
            "pinyin": "panzhihua"
        }, {
            "location_id": "746",
            "abbr": "8",
            "name_chs": "普洱",
            "location_type": "2",
            "parent_id": "265",
            "pinyin": "puer"
        }, {
            "location_id": "445",
            "abbr": "11",
            "name_chs": "盘锦",
            "location_type": "2",
            "parent_id": "246",
            "pinyin": "panjin"
        }, {
            "location_id": "531",
            "abbr": "3",
            "name_chs": "莆田",
            "location_type": "2",
            "parent_id": "253",
            "pinyin": "putian"
        }, {
            "location_id": "540",
            "abbr": "3",
            "name_chs": "萍乡",
            "location_type": "2",
            "parent_id": "254",
            "pinyin": "pingxiang"
        }],
        "Q": [{
            "location_id": "466",
            "abbr": "9",
            "name_chs": "七台河",
            "location_type": "2",
            "parent_id": "248",
            "pinyin": "qitaihe"
        }, {
            "location_id": "782",
            "abbr": "10",
            "name_chs": "庆阳",
            "location_type": "2",
            "parent_id": "268",
            "pinyin": "qingyang"
        }, {
            "location_id": "741",
            "abbr": "3",
            "name_chs": "曲靖",
            "location_type": "2",
            "parent_id": "265",
            "pinyin": "qujing"
        }, {
            "location_id": "533",
            "abbr": "5",
            "name_chs": "泉州",
            "location_type": "2",
            "parent_id": "253",
            "pinyin": "quanzhou"
        }, {
            "location_id": "630",
            "abbr": "18",
            "name_chs": "清远",
            "location_type": "2",
            "parent_id": "259",
            "pinyin": "qingyuan"
        }, {
            "location_id": "598",
            "abbr": "95",
            "name_chs": "潜江",
            "location_type": "2",
            "parent_id": "257",
            "pinyin": "qianjiang"
        }, {
            "location_id": "654",
            "abbr": "92",
            "name_chs": "琼海市",
            "location_type": "2",
            "parent_id": "261",
            "pinyin": "qionghai"
        }, {
            "location_id": "403",
            "abbr": "3",
            "name_chs": "秦皇岛",
            "location_type": "2",
            "parent_id": "243",
            "pinyin": "qinhuangdao"
        }, {
            "location_id": "642",
            "abbr": "7",
            "name_chs": "钦州",
            "location_type": "2",
            "parent_id": "260",
            "pinyin": "qinzhou"
        }, {
            "location_id": "550",
            "abbr": "2",
            "name_chs": "青岛",
            "location_type": "2",
            "parent_id": "255",
            "pinyin": "qingdao"
        }, {
            "location_id": "269",
            "abbr": "63",
            "name_chs": "青海",
            "location_type": "1",
            "parent_id": "1",
            "pinyin": "qinghai"
        }, {
            "location_id": "738",
            "abbr": "26",
            "name_chs": "黔东南",
            "location_type": "2",
            "parent_id": "264",
            "pinyin": "qiandongnan"
        }, {
            "location_id": "739",
            "abbr": "27",
            "name_chs": "黔南",
            "location_type": "2",
            "parent_id": "264",
            "pinyin": "qiannan"
        }, {
            "location_id": "736",
            "abbr": "23",
            "name_chs": "黔西南",
            "location_type": "2",
            "parent_id": "264",
            "pinyin": "qianxinan"
        }, {
            "location_id": "459",
            "abbr": "2",
            "name_chs": "齐齐哈尔",
            "location_type": "2",
            "parent_id": "248",
            "pinyin": "qiqihaer"
        }],
        "R": [{
            "location_id": "759",
            "abbr": "23",
            "name_chs": "日喀则",
            "location_type": "2",
            "parent_id": "266",
            "pinyin": "rikaze"
        }, {
            "location_id": "559",
            "abbr": "11",
            "name_chs": "日照",
            "location_type": "2",
            "parent_id": "255",
            "pinyin": "rizhao"
        }],
        "S": [{
            "location_id": "651",
            "abbr": "2",
            "name_chs": "三亚",
            "location_type": "2",
            "parent_id": "261",
            "pinyin": "sanya"
        }, {
            "location_id": "532",
            "abbr": "4",
            "name_chs": "三明",
            "location_type": "2",
            "parent_id": "253",
            "pinyin": "sanming"
        }, {
            "location_id": "652",
            "abbr": "3",
            "name_chs": "三沙",
            "location_type": "2",
            "parent_id": "261",
            "pinyin": "sansha"
        }, {
            "location_id": "577",
            "abbr": "12",
            "name_chs": "三门峡",
            "location_type": "2",
            "parent_id": "256",
            "pinyin": "sanmenxia"
        }, {
            "location_id": "249",
            "abbr": "31",
            "name_chs": "上海",
            "location_type": "1",
            "parent_id": "1",
            "pinyin": "shanghai"
        }, {
            "location_id": "548",
            "abbr": "11",
            "name_chs": "上饶",
            "location_type": "2",
            "parent_id": "254",
            "pinyin": "shangrao"
        }, {
            "location_id": "586",
            "abbr": "3",
            "name_chs": "十堰",
            "location_type": "2",
            "parent_id": "257",
            "pinyin": "shiyan"
        }, {
            "location_id": "462",
            "abbr": "5",
            "name_chs": "双鸭山",
            "location_type": "2",
            "parent_id": "248",
            "pinyin": "shuangyashan"
        }, {
            "location_id": "579",
            "abbr": "14",
            "name_chs": "商丘",
            "location_type": "2",
            "parent_id": "256",
            "pinyin": "shangqiu"
        }, {
            "location_id": "772",
            "abbr": "10",
            "name_chs": "商洛",
            "location_type": "2",
            "parent_id": "267",
            "pinyin": "shangluo"
        }, {
            "location_id": "263",
            "abbr": "51",
            "name_chs": "四川",
            "location_type": "1",
            "parent_id": "1",
            "pinyin": "sichuan"
        }, {
            "location_id": "451",
            "abbr": "3",
            "name_chs": "四平",
            "location_type": "2",
            "parent_id": "247",
            "pinyin": "siping"
        }, {
            "location_id": "524",
            "abbr": "13",
            "name_chs": "宿州",
            "location_type": "2",
            "parent_id": "252",
            "pinyin": "suzhou"
        }, {
            "location_id": "501",
            "abbr": "13",
            "name_chs": "宿迁",
            "location_type": "2",
            "parent_id": "250",
            "pinyin": "suqian"
        }, {
            "location_id": "255",
            "abbr": "37",
            "name_chs": "山东",
            "location_type": "1",
            "parent_id": "1",
            "pinyin": "shandong"
        }, {
            "location_id": "758",
            "abbr": "22",
            "name_chs": "山南",
            "location_type": "2",
            "parent_id": "266",
            "pinyin": "shannan"
        }, {
            "location_id": "244",
            "abbr": "14",
            "name_chs": "山西",
            "location_type": "1",
            "parent_id": "1",
            "pinyin": "shanxi"
        }, {
            "location_id": "417",
            "abbr": "6",
            "name_chs": "朔州",
            "location_type": "2",
            "parent_id": "244",
            "pinyin": "shuozhou"
        }, {
            "location_id": "455",
            "abbr": "7",
            "name_chs": "松原",
            "location_type": "2",
            "parent_id": "247",
            "pinyin": "songyuan"
        }, {
            "location_id": "619",
            "abbr": "5",
            "name_chs": "汕头",
            "location_type": "2",
            "parent_id": "259",
            "pinyin": "shantou"
        }, {
            "location_id": "627",
            "abbr": "15",
            "name_chs": "汕尾",
            "location_type": "2",
            "parent_id": "259",
            "pinyin": "shanwei"
        }, {
            "location_id": "435",
            "abbr": "1",
            "name_chs": "沈阳",
            "location_type": "2",
            "parent_id": "246",
            "pinyin": "shenyang"
        }, {
            "location_id": "617",
            "abbr": "3",
            "name_chs": "深圳",
            "location_type": "2",
            "parent_id": "259",
            "pinyin": "shen"
        }, {
            "location_id": "796",
            "abbr": "2",
            "name_chs": "石嘴山",
            "location_type": "2",
            "parent_id": "270",
            "pinyin": "shizuishan"
        }, {
            "location_id": "401",
            "abbr": "1",
            "name_chs": "石家庄",
            "location_type": "2",
            "parent_id": "243",
            "pinyin": "shijiazhuang"
        }, {
            "location_id": "814",
            "abbr": "91",
            "name_chs": "石河子",
            "location_type": "2",
            "parent_id": "271",
            "pinyin": "shihezi"
        }, {
            "location_id": "600",
            "abbr": "A21",
            "name_chs": "神农架",
            "location_type": "2",
            "parent_id": "257",
            "pinyin": "shennongjia"
        }, {
            "location_id": "507",
            "abbr": "6",
            "name_chs": "绍兴",
            "location_type": "2",
            "parent_id": "251",
            "pinyin": "shaoxing"
        }, {
            "location_id": "469",
            "abbr": "12",
            "name_chs": "绥化",
            "location_type": "2",
            "parent_id": "248",
            "pinyin": "suihua"
        }, {
            "location_id": "493",
            "abbr": "5",
            "name_chs": "苏州",
            "location_type": "2",
            "parent_id": "250",
            "pinyin": "suzhou"
        }, {
            "location_id": "717",
            "abbr": "9",
            "name_chs": "遂宁",
            "location_type": "2",
            "parent_id": "263",
            "pinyin": "suining"
        }, {
            "location_id": "605",
            "abbr": "5",
            "name_chs": "邵阳",
            "location_type": "2",
            "parent_id": "258",
            "pinyin": "shaoyang"
        }, {
            "location_id": "267",
            "abbr": "61",
            "name_chs": "陕西",
            "location_type": "1",
            "parent_id": "1",
            "pinyin": "shanxi"
        }, {
            "location_id": "595",
            "abbr": "13",
            "name_chs": "随州",
            "location_type": "2",
            "parent_id": "257",
            "pinyin": "suizhou"
        }, {
            "location_id": "616",
            "abbr": "2",
            "name_chs": "韶关",
            "location_type": "2",
            "parent_id": "259",
            "pinyin": "shaoguan"
        }],
        "T": [{
            "location_id": "822",
            "abbr": "4",
            "name_chs": "台中市",
            "location_type": "2",
            "parent_id": "272",
            "pinyin": "taizhongshi"
        }, {
            "location_id": "819",
            "abbr": "1",
            "name_chs": "台北市",
            "location_type": "2",
            "parent_id": "272",
            "pinyin": "taibeishi"
        }, {
            "location_id": "823",
            "abbr": "5",
            "name_chs": "台南市",
            "location_type": "2",
            "parent_id": "272",
            "pinyin": "tainanshi"
        }, {
            "location_id": "511",
            "abbr": "10",
            "name_chs": "台州",
            "location_type": "2",
            "parent_id": "251",
            "pinyin": "taizhou"
        }, {
            "location_id": "272",
            "abbr": "71",
            "name_chs": "台湾",
            "location_type": "1",
            "parent_id": "1",
            "pinyin": "taiwan"
        }, {
            "location_id": "802",
            "abbr": "21",
            "name_chs": "吐鲁番",
            "location_type": "2",
            "parent_id": "271",
            "pinyin": "tulufan"
        }, {
            "location_id": "402",
            "abbr": "2",
            "name_chs": "唐山",
            "location_type": "2",
            "parent_id": "243",
            "pinyin": "tangshan"
        }, {
            "location_id": "816",
            "abbr": "93",
            "name_chs": "图木舒克",
            "location_type": "2",
            "parent_id": "271",
            "pinyin": "tumushuke"
        }, {
            "location_id": "812",
            "abbr": "42",
            "name_chs": "塔城",
            "location_type": "2",
            "parent_id": "271",
            "pinyin": "tacheng"
        }, {
            "location_id": "777",
            "abbr": "5",
            "name_chs": "天水",
            "location_type": "2",
            "parent_id": "268",
            "pinyin": "tianshui"
        }, {
            "location_id": "242",
            "abbr": "12",
            "name_chs": "天津",
            "location_type": "1",
            "parent_id": "1",
            "pinyin": "tianjin"
        }, {
            "location_id": "599",
            "abbr": "96",
            "name_chs": "天门",
            "location_type": "2",
            "parent_id": "257",
            "pinyin": "tianmen"
        }, {
            "location_id": "412",
            "abbr": "1",
            "name_chs": "太原",
            "location_type": "2",
            "parent_id": "244",
            "pinyin": "taiyuan"
        }, {
            "location_id": "557",
            "abbr": "9",
            "name_chs": "泰安",
            "location_type": "2",
            "parent_id": "255",
            "pinyin": "taian"
        }, {
            "location_id": "500",
            "abbr": "12",
            "name_chs": "泰州",
            "location_type": "2",
            "parent_id": "250",
            "pinyin": "taizhou"
        }, {
            "location_id": "453",
            "abbr": "5",
            "name_chs": "通化",
            "location_type": "2",
            "parent_id": "247",
            "pinyin": "tonghua"
        }, {
            "location_id": "427",
            "abbr": "5",
            "name_chs": "通辽",
            "location_type": "2",
            "parent_id": "245",
            "pinyin": "tongliao"
        }, {
            "location_id": "446",
            "abbr": "12",
            "name_chs": "铁岭",
            "location_type": "2",
            "parent_id": "246",
            "pinyin": "tieling"
        }, {
            "location_id": "735",
            "abbr": "22",
            "name_chs": "铜仁",
            "location_type": "2",
            "parent_id": "264",
            "pinyin": "tongren"
        }, {
            "location_id": "764",
            "abbr": "2",
            "name_chs": "铜川",
            "location_type": "2",
            "parent_id": "267",
            "pinyin": "tongchuan"
        }, {
            "location_id": "519",
            "abbr": "7",
            "name_chs": "铜陵",
            "location_type": "2",
            "parent_id": "252",
            "pinyin": "tongling"
        }],
        "W": [{
            "location_id": "657",
            "abbr": "96",
            "name_chs": "万宁市",
            "location_type": "2",
            "parent_id": "261",
            "pinyin": "wanning"
        }, {
            "location_id": "431",
            "abbr": "9",
            "name_chs": "乌兰察布",
            "location_type": "2",
            "parent_id": "245",
            "pinyin": "wulanchabu"
        }, {
            "location_id": "425",
            "abbr": "3",
            "name_chs": "乌海",
            "location_type": "2",
            "parent_id": "245",
            "pinyin": "wuhai"
        }, {
            "location_id": "800",
            "abbr": "1",
            "name_chs": "乌鲁木齐",
            "location_type": "2",
            "parent_id": "271",
            "pinyin": "wulumuqi"
        }, {
            "location_id": "817",
            "abbr": "94",
            "name_chs": "五家渠",
            "location_type": "2",
            "parent_id": "271",
            "pinyin": "wujiaqu"
        }, {
            "location_id": "653",
            "abbr": "91",
            "name_chs": "五指山市",
            "location_type": "2",
            "parent_id": "261",
            "pinyin": "wuzhishan"
        }, {
            "location_id": "797",
            "abbr": "3",
            "name_chs": "吴忠",
            "location_type": "2",
            "parent_id": "270",
            "pinyin": "wuzhong"
        }, {
            "location_id": "558",
            "abbr": "10",
            "name_chs": "威海",
            "location_type": "2",
            "parent_id": "255",
            "pinyin": "weihai"
        }, {
            "location_id": "750",
            "abbr": "26",
            "name_chs": "文山",
            "location_type": "2",
            "parent_id": "265",
            "pinyin": "wenshan"
        }, {
            "location_id": "656",
            "abbr": "95",
            "name_chs": "文昌市",
            "location_type": "2",
            "parent_id": "261",
            "pinyin": "wenchang"
        }, {
            "location_id": "490",
            "abbr": "2",
            "name_chs": "无锡",
            "location_type": "2",
            "parent_id": "250",
            "pinyin": "wuxi"
        }, {
            "location_id": "639",
            "abbr": "4",
            "name_chs": "梧州",
            "location_type": "2",
            "parent_id": "260",
            "pinyin": "wuzhou"
        }, {
            "location_id": "778",
            "abbr": "6",
            "name_chs": "武威",
            "location_type": "2",
            "parent_id": "268",
            "pinyin": "wuwei"
        }, {
            "location_id": "584",
            "abbr": "1",
            "name_chs": "武汉",
            "location_type": "2",
            "parent_id": "257",
            "pinyin": "wuhan"
        }, {
            "location_id": "504",
            "abbr": "3",
            "name_chs": "温州",
            "location_type": "2",
            "parent_id": "251",
            "pinyin": "wenzhou"
        }, {
            "location_id": "767",
            "abbr": "5",
            "name_chs": "渭南",
            "location_type": "2",
            "parent_id": "267",
            "pinyin": "weinan"
        }, {
            "location_id": "555",
            "abbr": "7",
            "name_chs": "潍坊",
            "location_type": "2",
            "parent_id": "255",
            "pinyin": "weifang"
        }, {
            "location_id": "514",
            "abbr": "2",
            "name_chs": "芜湖",
            "location_type": "2",
            "parent_id": "252",
            "pinyin": "wuhu"
        }],
        "X": [{
            "location_id": "597",
            "abbr": "94",
            "name_chs": "仙桃",
            "location_type": "2",
            "parent_id": "257",
            "pinyin": "xiantao"
        }, {
            "location_id": "580",
            "abbr": "15",
            "name_chs": "信阳",
            "location_type": "2",
            "parent_id": "256",
            "pinyin": "xinyang"
        }, {
            "location_id": "432",
            "abbr": "22",
            "name_chs": "兴安盟",
            "location_type": "2",
            "parent_id": "245",
            "pinyin": "xingan"
        }, {
            "location_id": "530",
            "abbr": "2",
            "name_chs": "厦门",
            "location_type": "2",
            "parent_id": "253",
            "pinyin": "xiamen"
        }, {
            "location_id": "594",
            "abbr": "12",
            "name_chs": "咸宁",
            "location_type": "2",
            "parent_id": "257",
            "pinyin": "xianning"
        }, {
            "location_id": "766",
            "abbr": "4",
            "name_chs": "咸阳",
            "location_type": "2",
            "parent_id": "267",
            "pinyin": "xianyang"
        }, {
            "location_id": "591",
            "abbr": "9",
            "name_chs": "孝感",
            "location_type": "2",
            "parent_id": "257",
            "pinyin": "xiaogan"
        }, {
            "location_id": "528",
            "abbr": "18",
            "name_chs": "宣城",
            "location_type": "2",
            "parent_id": "252",
            "pinyin": "xuancheng"
        }, {
            "location_id": "491",
            "abbr": "3",
            "name_chs": "徐州",
            "location_type": "2",
            "parent_id": "250",
            "pinyin": "xuzhou"
        }, {
            "location_id": "420",
            "abbr": "9",
            "name_chs": "忻州",
            "location_type": "2",
            "parent_id": "244",
            "pinyin": "xinzhou"
        }, {
            "location_id": "572",
            "abbr": "7",
            "name_chs": "新乡",
            "location_type": "2",
            "parent_id": "256",
            "pinyin": "xinxiang"
        }, {
            "location_id": "542",
            "abbr": "5",
            "name_chs": "新余",
            "location_type": "2",
            "parent_id": "254",
            "pinyin": "xinyu"
        }, {
            "location_id": "271",
            "abbr": "65",
            "name_chs": "新疆",
            "location_type": "1",
            "parent_id": "1",
            "pinyin": "xinjiang"
        }, {
            "location_id": "824",
            "abbr": "6",
            "name_chs": "新竹市",
            "location_type": "2",
            "parent_id": "272",
            "pinyin": "xinzhushi"
        }, {
            "location_id": "603",
            "abbr": "3",
            "name_chs": "湘潭",
            "location_type": "2",
            "parent_id": "258",
            "pinyin": "xiangtan"
        }, {
            "location_id": "614",
            "abbr": "31",
            "name_chs": "湘西",
            "location_type": "2",
            "parent_id": "258",
            "pinyin": "xiangxi"
        }, {
            "location_id": "588",
            "abbr": "6",
            "name_chs": "襄阳",
            "location_type": "2",
            "parent_id": "257",
            "pinyin": "xiangyang"
        }, {
            "location_id": "751",
            "abbr": "28",
            "name_chs": "西双版纳",
            "location_type": "2",
            "parent_id": "265",
            "pinyin": "xishuangbanna"
        }, {
            "location_id": "787",
            "abbr": "1",
            "name_chs": "西宁",
            "location_type": "2",
            "parent_id": "269",
            "pinyin": "xining"
        }, {
            "location_id": "763",
            "abbr": "1",
            "name_chs": "西安",
            "location_type": "2",
            "parent_id": "267",
            "pinyin": "xian"
        }, {
            "location_id": "266",
            "abbr": "54",
            "name_chs": "西藏",
            "location_type": "1",
            "parent_id": "1",
            "pinyin": "xicang"
        }, {
            "location_id": "575",
            "abbr": "10",
            "name_chs": "许昌",
            "location_type": "2",
            "parent_id": "256",
            "pinyin": "xuchang"
        }, {
            "location_id": "405",
            "abbr": "5",
            "name_chs": "邢台",
            "location_type": "2",
            "parent_id": "243",
            "pinyin": "xingtai"
        }, {
            "location_id": "433",
            "abbr": "25",
            "name_chs": "锡林郭勒盟",
            "location_type": "2",
            "parent_id": "245",
            "pinyin": "xilinguole"
        }, {
            "location_id": "273",
            "abbr": "81",
            "name_chs": "香港",
            "location_type": "1",
            "parent_id": "1",
            "pinyin": "xianggang"
        }],
        "Y": [{
            "location_id": "265",
            "abbr": "53",
            "name_chs": "云南",
            "location_type": "1",
            "parent_id": "1",
            "pinyin": "yunnan"
        }, {
            "location_id": "635",
            "abbr": "53",
            "name_chs": "云浮",
            "location_type": "2",
            "parent_id": "259",
            "pinyin": "yunfu"
        }, {
            "location_id": "464",
            "abbr": "7",
            "name_chs": "伊春",
            "location_type": "2",
            "parent_id": "248",
            "pinyin": "yichun"
        }, {
            "location_id": "811",
            "abbr": "40",
            "name_chs": "伊犁",
            "location_type": "2",
            "parent_id": "271",
            "pinyin": "yili"
        }, {
            "location_id": "722",
            "abbr": "15",
            "name_chs": "宜宾",
            "location_type": "2",
            "parent_id": "263",
            "pinyin": "yibin"
        }, {
            "location_id": "587",
            "abbr": "5",
            "name_chs": "宜昌",
            "location_type": "2",
            "parent_id": "257",
            "pinyin": "yichang"
        }, {
            "location_id": "546",
            "abbr": "9",
            "name_chs": "宜春",
            "location_type": "2",
            "parent_id": "254",
            "pinyin": "yichun"
        }, {
            "location_id": "606",
            "abbr": "6",
            "name_chs": "岳阳",
            "location_type": "2",
            "parent_id": "258",
            "pinyin": "yueyang"
        }, {
            "location_id": "768",
            "abbr": "6",
            "name_chs": "延安",
            "location_type": "2",
            "parent_id": "267",
            "pinyin": "yanan"
        }, {
            "location_id": "457",
            "abbr": "24",
            "name_chs": "延边",
            "location_type": "2",
            "parent_id": "247",
            "pinyin": "yanbian"
        }, {
            "location_id": "498",
            "abbr": "10",
            "name_chs": "扬州",
            "location_type": "2",
            "parent_id": "250",
            "pinyin": "yangzhou"
        }, {
            "location_id": "770",
            "abbr": "8",
            "name_chs": "榆林",
            "location_type": "2",
            "parent_id": "267",
            "pinyin": "yulin"
        }, {
            "location_id": "611",
            "abbr": "11",
            "name_chs": "永州",
            "location_type": "2",
            "parent_id": "258",
            "pinyin": "yongzhou"
        }, {
            "location_id": "574",
            "abbr": "9",
            "name_chs": "濮阳",
            "location_type": "2",
            "parent_id": "256",
            "pinyin": "yang"
        }, {
            "location_id": "554",
            "abbr": "6",
            "name_chs": "烟台",
            "location_type": "2",
            "parent_id": "255",
            "pinyin": "yantai"
        }, {
            "location_id": "644",
            "abbr": "9",
            "name_chs": "玉林",
            "location_type": "2",
            "parent_id": "260",
            "pinyin": "yulin"
        }, {
            "location_id": "793",
            "abbr": "27",
            "name_chs": "玉树",
            "location_type": "2",
            "parent_id": "269",
            "pinyin": "yushu"
        }, {
            "location_id": "742",
            "abbr": "4",
            "name_chs": "玉溪",
            "location_type": "2",
            "parent_id": "265",
            "pinyin": "yuxi"
        }, {
            "location_id": "609",
            "abbr": "9",
            "name_chs": "益阳",
            "location_type": "2",
            "parent_id": "258",
            "pinyin": "yiyang"
        }, {
            "location_id": "497",
            "abbr": "9",
            "name_chs": "盐城",
            "location_type": "2",
            "parent_id": "250",
            "pinyin": "yancheng"
        }, {
            "location_id": "442",
            "abbr": "8",
            "name_chs": "营口",
            "location_type": "2",
            "parent_id": "246",
            "pinyin": "yingkou"
        }, {
            "location_id": "419",
            "abbr": "8",
            "name_chs": "运城",
            "location_type": "2",
            "parent_id": "244",
            "pinyin": "yuncheng"
        }, {
            "location_id": "795",
            "abbr": "1",
            "name_chs": "银川",
            "location_type": "2",
            "parent_id": "270",
            "pinyin": "yinchuan"
        }, {
            "location_id": "629",
            "abbr": "17",
            "name_chs": "阳江",
            "location_type": "2",
            "parent_id": "259",
            "pinyin": "yangjiang"
        }, {
            "location_id": "414",
            "abbr": "3",
            "name_chs": "阳泉",
            "location_type": "2",
            "parent_id": "244",
            "pinyin": "yangquan"
        }, {
            "location_id": "725",
            "abbr": "18",
            "name_chs": "雅安",
            "location_type": "2",
            "parent_id": "263",
            "pinyin": "yaan"
        }, {
            "location_id": "543",
            "abbr": "6",
            "name_chs": "鹰潭",
            "location_type": "2",
            "parent_id": "254",
            "pinyin": "yingtan"
        }],
        "Z": [{
            "location_id": "799",
            "abbr": "5",
            "name_chs": "中卫",
            "location_type": "2",
            "parent_id": "270",
            "pinyin": "zhongwei"
        }, {
            "location_id": "632",
            "abbr": "20",
            "name_chs": "中山",
            "location_type": "2",
            "parent_id": "259",
            "pinyin": "zhongshan"
        }, {
            "location_id": "526",
            "abbr": "16",
            "name_chs": "亳州",
            "location_type": "2",
            "parent_id": "252",
            "pinyin": "zhou"
        }, {
            "location_id": "655",
            "abbr": "93",
            "name_chs": "儋州市",
            "location_type": "2",
            "parent_id": "261",
            "pinyin": "zhou"
        }, {
            "location_id": "581",
            "abbr": "16",
            "name_chs": "周口",
            "location_type": "2",
            "parent_id": "256",
            "pinyin": "zhoukou"
        }, {
            "location_id": "407",
            "abbr": "7",
            "name_chs": "张家口",
            "location_type": "2",
            "parent_id": "243",
            "pinyin": "zhangjiakou"
        }, {
            "location_id": "608",
            "abbr": "8",
            "name_chs": "张家界",
            "location_type": "2",
            "parent_id": "258",
            "pinyin": "zhangjiajie"
        }, {
            "location_id": "779",
            "abbr": "7",
            "name_chs": "张掖",
            "location_type": "2",
            "parent_id": "268",
            "pinyin": "zhangye"
        }, {
            "location_id": "744",
            "abbr": "6",
            "name_chs": "昭通",
            "location_type": "2",
            "parent_id": "265",
            "pinyin": "zhaotong"
        }, {
            "location_id": "552",
            "abbr": "4",
            "name_chs": "枣庄",
            "location_type": "2",
            "parent_id": "255",
            "pinyin": "zaozhuang"
        }, {
            "location_id": "602",
            "abbr": "2",
            "name_chs": "株洲",
            "location_type": "2",
            "parent_id": "258",
            "pinyin": "zhuzhou"
        }, {
            "location_id": "713",
            "abbr": "5",
            "name_chs": "泸州",
            "location_type": "2",
            "parent_id": "263",
            "pinyin": "zhou"
        }, {
            "location_id": "251",
            "abbr": "33",
            "name_chs": "浙江",
            "location_type": "1",
            "parent_id": "1",
            "pinyin": "zhejiang"
        }, {
            "location_id": "551",
            "abbr": "3",
            "name_chs": "淄博",
            "location_type": "2",
            "parent_id": "255",
            "pinyin": "zibo"
        }, {
            "location_id": "622",
            "abbr": "8",
            "name_chs": "湛江",
            "location_type": "2",
            "parent_id": "259",
            "pinyin": "zhanjiang"
        }, {
            "location_id": "534",
            "abbr": "6",
            "name_chs": "漳州",
            "location_type": "2",
            "parent_id": "253",
            "pinyin": "zhangzhou"
        }, {
            "location_id": "618",
            "abbr": "4",
            "name_chs": "珠海",
            "location_type": "2",
            "parent_id": "259",
            "pinyin": "zhuhai"
        }, {
            "location_id": "624",
            "abbr": "12",
            "name_chs": "肇庆",
            "location_type": "2",
            "parent_id": "259",
            "pinyin": "zhaoqing"
        }, {
            "location_id": "711",
            "abbr": "3",
            "name_chs": "自贡",
            "location_type": "2",
            "parent_id": "263",
            "pinyin": "zigong"
        }, {
            "location_id": "510",
            "abbr": "9",
            "name_chs": "舟山",
            "location_type": "2",
            "parent_id": "251",
            "pinyin": "zhoushan"
        }, {
            "location_id": "509",
            "abbr": "8",
            "name_chs": "衢州",
            "location_type": "2",
            "parent_id": "251",
            "pinyin": "zhou"
        }, {
            "location_id": "727",
            "abbr": "20",
            "name_chs": "资阳",
            "location_type": "2",
            "parent_id": "263",
            "pinyin": "ziyang"
        }, {
            "location_id": "733",
            "abbr": "3",
            "name_chs": "遵义",
            "location_type": "2",
            "parent_id": "264",
            "pinyin": "zunyi"
        }, {
            "location_id": "566",
            "abbr": "1",
            "name_chs": "郑州",
            "location_type": "2",
            "parent_id": "256",
            "pinyin": "zhengzhou"
        }, {
            "location_id": "499",
            "abbr": "11",
            "name_chs": "镇江",
            "location_type": "2",
            "parent_id": "250",
            "pinyin": "zhenjiang"
        }, {
            "location_id": "582",
            "abbr": "17",
            "name_chs": "驻马店",
            "location_type": "2",
            "parent_id": "256",
            "pinyin": "zhumadian"
        }]
    }
}

export default cities;